const datePickTypes = [
  "year",
  "month",
  "date",
  "dates",
  "week",
  "datetime",
  "datetimerange",
  "daterange",
  "monthrange"
];

export { datePickTypes };
//# sourceMappingURL=date-pick.mjs.map
